module.exports = __webpack_public_path__ + "static/img/Bachelor_010551.c11a56f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010551.jpg
// module id = 187
// module chunks = 0